/**
 * Created by Mikhail Menshenin on 18.09.2025
 */

const AisensiaTimer = function (styles, timeLeft, onFinish, options) {
    options = options || {};

    const node = new cc.Node();

    node.setAnchorPoint(0.5, 0.5);
    node.setCascadeOpacityEnabled(true);

    const bg = new cc.Scale9Sprite(styles.background || bundles.windows.frames.window_bottom_panel_png);
    bg.setAnchorPoint(0, 0);
    bg.setContentSize(styles.width, styles.height || bg.height);
    node.setContentSize2(bg.getContentSize());
    node.addChild(bg);

    const countDown = timeLeft < 0 ? timeLeft : new cleverapps.CountDown(timeLeft, { onFinish });
    const timer = new cleverapps.CountDownView(countDown, {
        font: styles.font || cleverapps.styles.FONTS.TIMER_TEXT
    }, {
        timerEndText: options.timerEndText
    });

    let icon;
    if (styles.spine) {
        icon = new cleverapps.Spine(styles.spine);
        icon.setAnimation(0, styles.animation, true);
    } else {
        icon = new cc.Sprite(styles.icon || bundles.big_timer.frames.big_timer_png);
        if (styles.iconSize) {
            cleverapps.UI.fitToBox(icon, styles.iconSize);
        }
    }
    timer.setCascadeOpacityEnabled(true);

    const layout = new cleverapps.Layout([icon, timer], {
        direction: cleverapps.UI.HORIZONTAL,
        margin: styles.margin,
        padding: styles.padding
    });
    layout.setAlignment(styles.layout);
    node.addChild(layout);

    return node;
};
